import { FormattedMessage as FM } from "react-intl";

function LabelRowSection(props) {
  const { data: value, children } = props;
  const styleChildren = children ? "flex  space-x-2" : null;
  let _value = value;

  if (props.translate) {
    _value = <FM id={props.data} />;
  }
  return (
    <div className={styleChildren}>
      <div>
        <h3 className="text-[17px] md:font-medium text-neutral-400  ">
          <FM id={props.label} name={props.label} />
        </h3>
        <span className="text-[14px] uppercase  text-neutral-800">
          {_value}
        </span>
      </div>
      {children && <span>{children}</span>}
    </div>
  );
}

export default LabelRowSection;
